import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

@Injectable({
  providedIn: 'root'
})
export class AiSearchService {

  constructor(private http: HttpClient) {}

  search(query: string): Observable<any[]> {
    return this.http.post<any[]>( APIURLConstantsService._API_BASE_URL + 'ai/search', { query } 
    );
  }
}